import {h} from 'preact';

export default ({enable}) => (
    <div className="triggerManualInput" onClick={enable}>
        ... oder Schule/Institution manuell eintragen
    </div>
)
